export const RECEIVE_ADD_ONS = 'RECEIVE_ADD_ONS';
export const RECEIVE_SOFT_BUNDLE = 'RECEIVE_SOFT_BUNDLE';

export const receiveAddons = (sku, addOns) => ({
    type: RECEIVE_ADD_ONS,
    sku,
    addOns,
});

export const receiveSoftBundle = (sku, softBundlesAddOns) => ({
    type: RECEIVE_SOFT_BUNDLE,
    sku,
    softBundlesAddOns,
});

export const setAddOns = (sku, addOns) => (dispatch, getState) => {
    return dispatch(receiveAddons(sku, addOns));
};

export const setSoftBundle = (sku, addOns) => (dispatch, getState) => {
    return dispatch(receiveSoftBundle(sku, addOns));
};
